"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var CampaignCardBase = _base.default.makeDefaultCardType('campaign', 'Campaign');

var CampaignCard =
/*#__PURE__*/
function (_CampaignCardBase) {
  babelHelpers.inherits(CampaignCard, _CampaignCardBase);

  function CampaignCard() {
    babelHelpers.classCallCheck(this, CampaignCard);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(CampaignCard).apply(this, arguments));
  }

  babelHelpers.createClass(CampaignCard, null, [{
    key: "makeCampaignCardType",
    value: function makeCampaignCardType(id, typeLabel) {
      var _class, _temp;

      return _temp = _class =
      /*#__PURE__*/
      function (_this) {
        babelHelpers.inherits(_class, _this);

        function _class() {
          babelHelpers.classCallCheck(this, _class);
          return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class).apply(this, arguments));
        }

        return _class;
      }(this), _class.campaignId = id, _class.campaignTypeLabel = typeLabel, _temp;
    }
  }]);
  return CampaignCard;
}(CampaignCardBase);

exports.default = CampaignCard;
CampaignCard.campaignId = "";
CampaignCard.campaignTypeLabel = "Campaign";